import { useDispatch } from 'react-redux';
import { Dispatch, SetStateAction } from 'react';
import { useTheme } from 'styled-components';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { Container, getSpacingToken, Grid, Stack, StackItem, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { SearchStateProps } from '../../Assistant';
import { StyledListItem, ThinDivider } from '../styles';
import { NoResultIcon } from './noResultIcon';
import { useNewEntity } from './useNewEntity';

interface NoResultProps {
    searchTerm: string;
    setSearchState: Dispatch<SetStateAction<SearchStateProps>>;
}

export const NoResult = ({ searchTerm, setSearchState }: NoResultProps) => {
    const dispatch: CommanderThunkDispatch = useDispatch();
    const list = useNewEntity(searchTerm);
    const theme = useTheme();
    const paddingBottom = getSpacingToken('150')({ theme });
    return (
        <Stack vertical spacing="100" style={{ overflowY: 'auto' }}>
            <Stack vertical spacing="25" itemAlignment="center" distribution="space-around">
                <StackItem padding="200">
                    <NoResultIcon />
                </StackItem>
                <StackItem>
                    <Stack spacing="50">
                        <StackItem>
                            <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                                {lt('AssistantSearchNoResultsIndicator')}{' '}
                            </Typography>
                        </StackItem>
                        <StackItem>
                            <Typography textStyle="bodyMediumStrong" as="div">
                                {searchTerm}
                            </Typography>
                        </StackItem>
                    </Stack>
                </StackItem>
                <StackItem padding="25">
                    <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                        {lt('AssistantSearchNoResultsTip')}
                    </Typography>
                </StackItem>
                {/*  <StackItem>
                    <Stack spacing="50" distribution="space-between">
                        <StackItem padding="200">
                            <Link strong>{lt('AssistantSearchNoResultsSubmitASupportTicket')}</Link>
                        </StackItem>
                        <StackItem padding="200">
                            <Link strong>{lt('AssistantSearchNoResultsAskTheCommunity')}</Link>
                        </StackItem>
                    </Stack>
                </StackItem> */}
            </Stack>
            <StackItem padding="50">
                <ThinDivider />
            </StackItem>
            <Container padding={['0', '200']}>
                <Grid
                    templateColumns="1fr"
                    alignContent="start"
                    alignItems="start"
                    gap="0"
                    justifyContent="stretch"
                    style={{ paddingBottom: `${paddingBottom}px` }}
                >
                    {list.map((listItemProps) => {
                        const { routeAction, itemId, ...props } = listItemProps;
                        return (
                            <StyledListItem
                                key={itemId}
                                onClick={(e) => {
                                    if (routeAction) {
                                        dispatch(routeAction);
                                        setSearchState((prev) => ({ ...prev, searchTerm: '', focused: false }));
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }
                                }}
                                {...props}
                            />
                        );
                    })}
                </Grid>
            </Container>
        </Stack>
    );
};
